/* eslint-disable max-len */
import * as Constants from './constants';

export const contestRequest = (filters) => ({
  type: Constants.CONTEST_REQUEST,
  filters,
})
export const contestSuccess = result => ({
  type: Constants.CONTEST_SUCCESS,
  result,
})
export const contestError = error => ({
  type: Constants.CONTEST_ERROR,
  error,
})

export const draftRequest = (contestId, toDraft) => ({
  type: Constants.DRAFT_REQUEST,
  contestId,
  toDraft,
})
export const draftSuccess = result => ({
  type: Constants.DRAFT_SUCCESS,
  result,
})
export const draftError = error => ({
  type: Constants.DRAFT_ERROR,
  error,
})
